export const Role = {
    Admin: "Admin",
    Provider: "Provider",
    User: "User",
    All: "All",
};
